module.exports = __webpack_public_path__ + "static/media/profJhaUdaan.97a5e716.jpg";